import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Tick');

class Tick extends PureComponent {

    render() {
        const { className, type } = this.props;

        return (
            <div className={bem('circle', type, className)}>
                <div className={bem('dot', type)} />
                <div className={bem('tick', type)} />
                <div className={bem('topHalfWindow', type)} />
                <div className={bem('bottomHalfWindow', type)} />
                <div className={bem('centerWindow', type)} />
            </div>
        );
    }
}

Tick.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
};

Tick.defaultProps = {};

export default Tick;
